import { DialogContent } from '@mui/material'
import React from 'react'

import Dialog from '@/app/component/atom/dialog'
import DialogHeader from '@/app/component/atom/dialog-header'

import TransferFunds from './transfer-funds'

type Props = {
  open: boolean
  onClose: () => void
}

const TransferFundsDialog: React.FC<Props> = ({ open, onClose }) => (
  <Dialog open={open} onClose={onClose}>
    <DialogHeader icon="sync_alt" title="Transfer funds to another organization" onClose={onClose} />
    <DialogContent>
      <TransferFunds onSuccess={onClose} />
    </DialogContent>
  </Dialog>
)

export default TransferFundsDialog
